<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Потенциальные клиенты</div>
                  <div class="breadcrumb">Монитор продаж / Потенциальные клиенты</div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-col style="width:90%; margin-left:10%;">
          <v-sheet
              rounded="lg"
          >
            <v-card-title
                class="custom__card-title"
            >
              <div class="search_client">
                <v-text-field
                    v-model="search"
                    rounded
                    outlined
                    dense
                    hide-details
                    single-line
                    label="Поиск"
                    style="font-size: 12px;font-weight: normal"
                    background-color="white"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>mdi-magnify</v-icon>
                  </template>
                </v-text-field>
                
              </div>
              <div v-if="list && list.monitor && !isLoading">
              </div>
              <div v-else>
                <span >Загрузка данных....</span>
              </div>
              <div class="filter_client">
                <v-btn
                    dark
                    class="filter-button"
                    :disabled="isLoading"
                    @click="dialogFiler = !dialogFiler"
                >
                  <img
                      class="mr-1"
                      src="/playground_assets/mediumfilter.svg"
                  >
                  Фильтр
                </v-btn>
              </div>

            </v-card-title>
            <v-card-text
                v-show="dialogFiler"
            >
              <v-container>
                <v-row>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Статус</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.status_deal"
                        :items="statusDealTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Клубы</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.club"
                        :items="clubTypes"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Этап</label>
                    <!-- <v-select
                    v-if="list && list.monitor"
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.current_stage"
                        :items="list.monitor"
                        item-value="deal.stage.id"
                        item-text="deal.stage.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select> -->
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.current_stage"
                        :items="stageTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Менеджер</label>
                    <!-- <v-select
                    v-if="list && list.monitor"
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.manager"
                        :items="list.monitor"
                        item-value="manager.id"
                        item-text="manager.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select> -->

                    <v-select
                      v-if="managersList && managersList.managers"
                                v-model="clientsFilter.manager"
                                :items="managersList.managers"
                                no-data-text="Нет доступных менеджеров"
                                item-text="name"
                                item-value="id"
                                class="rounded-lg"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                return-object
                            ></v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Кем создан</label>
                    <!-- <v-select
                    v-if="list && list.monitor"
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.user"
                        :items="list.monitor"
                        item-value="user.id"
                        item-text="user.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select> -->

                    <v-select
                      v-if="specialist && specialist.specialist"
                      @input="collectData"
                                v-model="clientsFilter.user"
                                :items="specialist.specialist"
                                no-data-text="Нет доступных менеджеров"
                                item-text="name"
                                item-value="id"
                                class="rounded-lg"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                return-object
                            ></v-select>

                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Источник</label>
                    <v-select
                    v-if="listSources"
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.advertising_source"
                        :items="listSources.advertising"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
           
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Тег</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.tag"
                        :items="tagsList"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Интерес</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.interests"
                        :items="interestsTypes"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Задачи</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.scheduled_task"
                        :items="scheduledTaskTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Сделки</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.type"
                        :items="dealsTypes"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Канал</label>
                    <v-select
                    v-if="listPlatforms && listPlatforms.advertising"
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.advertising_platform"
                        :items="listPlatforms.advertising"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Создана</label>
                    <VueDatePicker
                        @input="collectData"
                        no-title
                        no-header
                        range
                        rangeInputText="%d - %d"
                        format="DD MMMM"
                        color="#629f34"
                        v-model="clientsFilter.date_creation"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__datepicker"
                            ref="activator"
                            type="button"
                        >
                          <div>
                            <span v-if="clientsFilter.date_creation">{{ date }}</span>
                            <span v-else style="color: gray">Выберите период</span>
                          </div>
                          <v-icon
                              medium
                              right
                              class="ml-5"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                        </button>
                      </template>
                    </VueDatePicker>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Запланированная задача</label>
                    <VueDatePicker
                        @input="collectData"
                        no-title
                        no-header
                        range
                        rangeInputText="%d - %d"
                        format="DD MMMM"
                        color="#629f34"
                        v-model="clientsFilter.date_schedule"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__datepicker"
                            ref="activator"
                            type="button"
                        >
                          <div>
                            <span v-if="clientsFilter.date_schedule">{{ date }}</span>
                            <span v-else style="color: gray">Выберите период</span>
                          </div>
                          <v-icon
                              medium
                              right
                              class="ml-5"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                        </button>
                      </template>
                    </VueDatePicker>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Справка</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="clientsFilter.reference"
                        :items="referenceTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-card-actions class="mt-4">
                    <template v-if="!dialogButton">
                      <button
                          class="button custom__button mt-5"
                          type="button"
                          @click="returnClients"
                      >
                        Применить
                      </button>
                    </template>
                    <template v-else>
                      <button
                          class="button custom__button mt-5"
                          type="button"
                          @click="filterClients(clientsFilter)"
                          style="background-color: #A13453 !important;color: #fff !important;"
                      >
                        Применить
                      </button>
                      <button
                          class="button custom__button mt-5 ml-3"
                          type="button"
                          style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                          @click="clearData"
                      >
                        Сбросить фильтр
                      </button>
                    </template>
                  </v-card-actions>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- <v-data-table
            v-if="list && list.monitor"
                :headers="headersClients"
                :items="list.monitor"
                no-data-text="Результатов не найдено"
                :hide-default-footer="true"
                :page="page"
                :search="search"
                class="elevation-1"
                :server-items-length="list.listLength"
                :items-per-page="toggle_exclusive"
            >
              <template v-slot:body="{ items, headers }">
                <tbody name="list" is="transition-group" v-if="items.length > 0">
                  <tr v-for="item in items" :key="item.id">
                    <td>
                      <router-link
                          :to="{ name: 'CardClientNew', params: {client_id: item.id}}"
                          class="d-flex"
                          style="align-items: center; text-decoration: none; color: #000"
                      >
                        {{ item.name }}
                      </router-link>
                    </td>
                    <td>{{ formatDate(item.date_creation) }}</td>
                    <td>{{ item.tag }}</td>
                    <td>{{ item.interests }}</td>
                    <td v-if="item.deal && item.deal.stage" :style="'background-color: ' + item.deal.stage.colour">{{ item.deal.stage.name }}{{ item.deal.sum > 0 ? ', ' + item.deal.sum : '' }}{{ item.deal.name ? ', ' + item.deal.name : ''}}</td>
                    <td v-else></td>
                    <td>{{ item.advertising_source.name }}{{ item.advertising_platform.name ? ', ' + item.advertising_platform.name : ''}}</td>
                    <td>{{ item.scheduled_task.name }}</td>
                    <td>{{ item.manager.name }}</td>
                    <td>{{ item.user.name }}</td>
                    <td>{{ item.last_task.name }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                <tr class="v-data-table__empty-wrapper">
                  <td :colspan="headers.length">Потенциальных клиентов не найдено</td>
                </tr>
                </tbody>
              </template>
            </v-data-table> -->

            
            <v-data-table
                v-if="list && list.monitor && !isLoading"
                    :headers="headersClients"
                    :items="list.monitor"
                    no-data-text="Результатов не найдено"
                    :hide-default-footer="true"
                    :page="page"
                    class="elevation-1"
                    :server-items-length="list.monitor.listLength"
                    :items-per-page="toggle_exclusive"
            >
            <template v-slot:body="{ items, headers }">
                <tbody name="list" is="transition-group" v-if="items.length > 0">
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <router-link
                        :to="{ name: 'CardClientNew', params: {client_id: item.id}}"
                        class="d-flex"
                        style="align-items: center; text-decoration: none; color: #000"
                    >
                      {{ item.name ? item.name : ''}}
                    </router-link>
                  </td>
                  <td>{{ formatDate(item.date_creation) }}</td>
                  <td>{{ item.tag }}</td>
                  <td>{{ item.interests }}</td>
                  <td v-if="item.deal && item.deal.stage" :style="'background-color: ' + item.deal.stage.colour">{{ item.deal.stage.name }}{{ item.deal.sum > 0 ? ', ' + item.deal.sum : '' }}{{ item.deal.name ? ', ' + item.deal.name : ''}}</td>
                  <td>{{ item.advertising_source ? item.advertising_source.name : ''}}{{ item.advertising_platform ? ', ' + item.advertising_platform.name : ''}}</td>
                  <td>{{ item.scheduled_task ? item.scheduled_task.name : '' }}</td>
                  <td>{{ item.manager ? item.manager.name : ''}}</td>
                  <td>{{ item.user ? item.user.name : '' }}</td>
                  <td>{{ item.last_task ?  item.last_task.name : '' }}</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="v-data-table__empty-wrapper">
                  <td :colspan="headers.length">Потенциальных клиентов не найдено</td>
                </tr>
                </tbody>
              </template>
            </v-data-table>

            <v-card-actions
                      class="d-flex justify-content-between"
                      style="padding: 20px !important;"
                  >
                    <template v-if="list && list.listLength">
                      <div>
                        <span class="desktopRegularLabel"><span>Показано с 1 по {{ toggle_exclusive }} из {{ list.listLength }} результатов</span></span>
                      </div>
                      <div>
                        <v-pagination
                            v-model="page"
                            circle
                            color="#629F33"
                            :length="list.paginationLength"
                            :total-visible="8"
                        ></v-pagination>
                      </div>
                    </template>
                  </v-card-actions>
          </v-sheet>

        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {monitorActionTypes} from "@/store/modules/monitor";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {advertisingActionTypes} from "@/store/modules/advertising";
import {organizationActionTypes} from '@/store/modules/organization';
import {lessonActionTypes} from "@/store/modules/lesson";
import {tagsActionTypes} from '@/store/modules/tags';

export default {
  name: 'PotentialCustomers',
  props: ['specialistType', 'specialist_id', 'type', 'startdate', 'enddate'],
  components: {
    VueDatePicker,
    Header,
    Menu,
  },
  computed: {
    ...mapState({
      isLoading: state => state.monitor.isLoading,
      list: state => state.monitor.list,
      validationErrors: state => state.monitor.validationErrors,
      listPlatforms: state => state.advertising.listPlatforms,
      listSources: state => state.advertising.listSources,
      managersList: state => state.organization.managersList,
      specialist: state => state.lesson.specialist,
    })
  },
  methods: {
    fetchFeed(specialist_id, type, startdate, enddate, search, filter) {

      let page = this.page
      let limit = this.toggle_exclusive

      let client_search = search ? search : null
      let client_filter = filter ? filter : null

      setItem('customers-filter_obj', JSON.stringify(client_filter))

      if (type === 'nodeal') {
        this.$store.dispatch(monitorActionTypes.getNodealClients, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search,
          client_filter
        }).then((res) => {
          this.loading = false
        })
      } else if (type === 'notask') {
        this.$store.dispatch(monitorActionTypes.getNotaskClients, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search,
          client_filter
        }).then((res) => {
          this.loading = false
        })
      } else {
        this.$store.dispatch(monitorActionTypes.getActiveClients, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search,
          client_filter
        }).then((res) => {
          this.loading = false
        })
      }
    },
    collectData(selected) {
      this.selected.push(selected)
      // if (this.selected !== [] || this.clientsFilter.date_creation !== null || this.clientsFilter.date_end !== null || this.clientsFilter.date_schedule !== null) {
      //   this.dialogButton = true;
      // }
      if (this.selected === []){
        this.dialogButton = false;
      }
    },
    clearData() {
      this.selected.length = 0;
      this.clientsFilter.status_deal = null;
      this.clientsFilter.club = null;
      this.clientsFilter.current_stage = null;
      this.clientsFilter.manager = null;
      this.clientsFilter.user = null;
      this.clientsFilter.advertising_source = null;
      this.clientsFilter.tag = null;
      this.clientsFilter.interests = null;
      this.clientsFilter.scheduled_task = null;
      this.clientsFilter.type = null;
      this.clientsFilter.advertising_platform = null;
      this.clientsFilter.date_creation = null;
      this.clientsFilter.date_schedule = null;
      this.clientsFilter.reference = null;
      this.dialogButton = false;

      this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate);
    },
    filterClients(clients) {
      console.log(clients)
      console.log(this.clientsFilter)

      this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.clientsFilter);
      // if (clients.status_deal !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => (item.date_creation !== "") === clients.status_deal);
      // }
      // if (clients.club !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.club.id === clients.club);
      // }
      // if (clients.current_stage !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.current_stage.id === clients.current_stage);
      // }
      // if (clients.manager !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.manager.id === clients.manager);
      // }
      // if (clients.user !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.user.id === clients.user);
      // }
      // if (clients.advertising_source !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.advertising_source.id === clients.advertising_source);
      // }
      // if (clients.tag !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.tag === clients.tag);
      // }
      // if (clients.interests !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.interests === clients.interests);
      // }
      // if (clients.scheduled_task !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => (item.scheduled_task.length !== 0) === clients.scheduled_task);
      // }
      // if (clients.type !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.type.id === clients.type);
      // }
      // if (clients.advertising_platform !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.advertising_platform.id === clients.advertising_platform);
      // }
      // if (clients.date_creation !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => new Date(clients.date_creation.start) <= new Date(item.date_creation) && new Date(item.date_creation) <= new Date(clients.date_creation.end));
      // }
      // if (clients.date_schedule !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => new Date(clients.date_schedule.start) <= new Date(item.scheduled_task.date) && new Date(item.scheduled_task.date) <= new Date(clients.date_schedule.end));
      // }
      // if (clients.reference !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.reference === clients.reference);
      // }
    },
    returnClients() {
      if (!this.dialogButton) {
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate);
      }
    },
    formatDate(date) {
      date = new Date(date);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const formattedDay = (day < 10) ? `0${day}` : day;
      const formattedMonth = (month < 10) ? `0${month}` : month;

      return `${formattedDay}.${formattedMonth}.${year}`;
    }
  },
  mounted() {

    //this.isLoading = true

    //this.list = null

    console.log(this.type)

    if(getItem('customers-filter_obj') && getItem('customers-filter_obj') !== null && getItem('customers-filter_obj') !== undefined && getItem('customers-filter_obj') !== 'null'){

      this.clientsFilter = JSON.parse(getItem('customers-filter_obj'))

    }

    console.log(this.specialist_id)

    if(this.specialist_id && this.specialist_id !== undefined && this.specialist_id !== null && this.specialist_id !== 'null'){
      setItem('customers-specialist_id', this.specialist_id)
    } else {
      this.specialist_id = getItem('customers-specialist_id')
    }
    
    this.type !== undefined ? setItem('customers-type', this.type) : this.type = getItem('customers-type');
    if (this.startdate === undefined && this.enddate === undefined) {
      this.startdate = new Date();
      this.enddate = new Date();
    }

    if(getItem('customers-specialist_id') && getItem('customers-specialist_id') !== undefined && getItem('customers-specialist_id') !== null && getItem('customers-specialist_id') !== 'null'){

    } else {
      if(!this.specialistType || this.specialistType == 0) {
        this.specialist_id = null
      }
    }

    
    this.$store.dispatch(advertisingActionTypes.getPlatforms)
    this.$store.dispatch(advertisingActionTypes.getSources)
    
    this.$store.dispatch(organizationActionTypes.organizationManagersList).then((response) => {
        if(this.specialist_id) {
            if(response && response.managers){
              let managerDef = response.managers.filter((item) => this.specialist_id.includes(item.id));
              if(managerDef && managerDef[0] && managerDef[0].id){
                this.clientsFilter.manager = {
                  name: managerDef[0].name,
                  id: managerDef[0].id
                }

                this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.clientsFilter);
              } else {
                this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.clientsFilter);
              }
            }
        } else {
          this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.clientsFilter);
        }
    });
    this.$store.dispatch(lessonActionTypes.getSpecialistList);
    this.$store.dispatch(tagsActionTypes.tagsList).then((response => {
        if(response.success){
          this.tagsList = response.tags
        }
    }))
  },
  data() {
    return {
      loading:false,
      search: '',
      select: null,
      selected: [],
      dialogFiler: false,
      dialogButton: true,
      valid: true,
      clientsFilter: {
        status_deal: {name: 'Потенциальный', value: 'Потенциальный'},
        club: {name: 'КлеверСпорт Н.Челны', id: "2dd7fea2-587b-11ea-80e1-9c5c8e747603"},
        current_stage: null,
        manager: null,
        user: null,
        advertising_source: null,
        tag: null,
        interests: null,
        scheduled_task: (this.type === 'active') ? {name: 'Есть задачи', value: true} : {name: 'Нет задач', value: false},
        type: null,
        advertising_platform: null,
        date_creation: null,
        date_schedule: {start:this.startdate,end:this.enddate},
        reference: null
      },
      // statusDealTypes: [
      //   {name: 'Завершена', value: true},
      //   {name: 'Не завершена', value: false}
      // ],
      statusDealTypes: [
        {name: 'Потенциальный', value: "Потенциальный"}
      ],
      clubTypes: [
      {name: 'КлеверСпорт Н.Челны', id: "2dd7fea2-587b-11ea-80e1-9c5c8e747603"}
      ],
      dealsTypes: [
        {name: 'Есть сделки', id: true},
        {name: 'Нет сделок', id: false}
      ],
      scheduledTaskTypes: [
        {name: 'Есть задача', value: true},
        {name: 'Нет задач', value: false}
      ],
      stageTypes: [
        {name: 'Отказ', value: "361870a3-f7b5-11ea-8134-9c5c8e747603-0"}, //!
        {name: 'Успех', value: "361870a3-f7b5-11ea-8134-9c5c8e747603-01"}, //!
        {name: 'Контакт с клиентом', value: "361870a3-f7b5-11ea-8134-9c5c8e747603"},
        {name: 'Презентация клуба', value: "361870a4-f7b5-11ea-8134-9c5c8e747603"},
        {name: 'Пробное занятие', value: "361870a6-f7b5-11ea-8134-9c5c8e747603-02"}, //!
        {name: 'Оформление продажи', value: "361870a6-f7b5-11ea-8134-9c5c8e747603"}
      ],
      referenceTypes: [
        {name: 'Да', value: true},
        {name: 'Нет', value: false}
      ],
      interestsTypes:[
          {
              "id": "40f7d647-1277-11ee-a065-60e32700ce56",
              "name": "август",
              "flag_deletion": false
          },
          {
              "id": "0a4d935a-a697-11ec-a061-60e32700ce56",
              "name": "акция",
              "flag_deletion": false
          },
          {
              "id": "3007656d-3170-11eb-a05b-60e32700ce56",
              "name": "былтур",
              "flag_deletion": false
          },
          {
              "id": "69ee2112-3246-11eb-a05b-60e32700ce56",
              "name": "былтур",
              "flag_deletion": false
          },
          {
              "id": "d16ce0de-349b-11eb-a05b-60e32700ce56",
              "name": "гэс",
              "flag_deletion": false
          },
          {
              "id": "e2c5e3e7-421b-11f0-a07b-60e32700ce56",
              "name": "другой город",
              "flag_deletion": false
          },
          {
              "id": "045392bd-864b-11eb-a05d-60e32700ce56",
              "name": "замелекесье",
              "flag_deletion": false
          },
          {
              "id": "2bfae752-7f72-11ec-a061-60e32700ce56",
              "name": "не звонить",
              "flag_deletion": false
          },
          {
              "id": "d031e9fb-9195-11ed-a063-60e32700ce56",
              "name": "новый город",
              "flag_deletion": false
          },
          {
              "id": "59acd22a-0459-11ee-a065-60e32700ce56",
              "name": "Осень",
              "flag_deletion": false
          },
          {
              "id": "a163f459-93ee-11ed-a063-60e32700ce56",
              "name": "пенсионе",
              "flag_deletion": false
          },
          {
              "id": "0ca9f0cb-6a68-11ed-a063-60e32700ce56",
              "name": "переезд",
              "flag_deletion": false
          },
          {
              "id": "26a063b7-91af-11ed-a063-60e32700ce56",
              "name": "подумает подойдет",
              "flag_deletion": false
          },
          {
              "id": "88313da1-3534-11eb-a05b-60e32700ce56",
              "name": "розыгрыш НГ",
              "flag_deletion": false
          },
          {
              "id": "064c02e1-c043-11ee-a06c-60e3270104e0",
              "name": "СИБУР",
              "flag_deletion": false
          },
          {
              "id": "09338ea6-2b4a-11f0-a07b-60e32700ce56",
              "name": "список от вайнера ",
              "flag_deletion": false
          },
          {
              "id": "f64ed81e-3fa6-11eb-a05c-60e3270104e0",
              "name": "термо",
              "flag_deletion": false
          },
          {
              "id": "e63bb3ca-122a-11eb-8136-9c5c8e747603",
              "name": "тренажерный зал",
              "flag_deletion": false
          },
          {
              "id": "142e0513-024b-11eb-8136-9c5c8e747603",
              "name": "тур был",
              "flag_deletion": false
          },
          {
              "id": "8743dc7c-0ff0-11ec-a060-60e32700ce56",
              "name": "укрепление здоровья",
              "flag_deletion": false
          },
          {
              "id": "d5bf28f2-f8e9-11ea-8136-9c5c8e747603",
              "name": "хочет сбросить вес",
              "flag_deletion": false
          }
      ],
      headersClients: [
        {text: 'Клиент', align: 'start', value: 'name'},
        {text: 'Создана', value: 'date_creation'},
        {text: 'Тег', value: 'tag'},
        {text: 'Интересы', value: 'interests'},
        {text: 'Этап, Сумма, Вид сделки', value: 'deal_params'},
        {text: 'Рекламный источник, канал', value: 'advertising_params'},
        {text: 'Запланированная задача', value: 'scheduled_task.name'},
        {text: 'Менеджер', value: 'manager.name'},
        {text: 'Кем создан', value: 'user.name'},
        {text: 'Последняя задача', value: 'last_task.name'}
      ],
      page:1,
      toggle_exclusive: 20,
      tagsList:[]
    }
  },
  watch: {
    toggle_exclusive() {
      this.page = 1;
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.clientsFilter);
      }
    },
    page() {
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.clientsFilter);
      } else {
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.clientsFilter);
      }
    },
    search() {
      if (this.search !== '') {
        this.loading = true
        this.specialist_id !== undefined ? setItem('customers-specialist_id', this.specialist_id) : this.specialist_id = getItem('customers-specialist_id');
        this.type !== undefined ? setItem('customers-type', this.type) : this.type = getItem('customers-type');
        if (this.startdate === undefined && this.enddate === undefined) {
          this.startdate = new Date();
          this.enddate = new Date();
        }
        if(!this.specialistType || this.specialistType == 0) {
          this.specialist_id = null
        }
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.clientsFilter);
      } else {
        this.loading = true
        this.specialist_id !== undefined ? setItem('customers-specialist_id', this.specialist_id) : this.specialist_id = getItem('customers-specialist_id');
        this.type !== undefined ? setItem('customers-type', this.type) : this.type = getItem('customers-type');
        if (this.startdate === undefined && this.enddate === undefined) {
          this.startdate = new Date();
          this.enddate = new Date();
        }
        if(!this.specialistType || this.specialistType == 0) {
          this.specialist_id = null
        }
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.clientsFilter);
      }
    }
  }
}
</script>
<style scoped lang="scss">
.filter {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }
    }

  }

  .hidden-block {
    padding-top: 20px;

  }

  &__field {
    &.colspan-4 {
      grid-column: 1 / 5;
    }

    &.button-block {
      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .label {
      color: #1A1A1A;
      display: block;
      margin-bottom: 8px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  button {
    border-radius: 12px;
    text-transform: none;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    box-shadow: none;
    padding: 13px 21px;

    &.apply {
      background: #629F33 !important;
      color: #fff !important;
    }

    &.clear {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
    }

  }
}

.min-w-173 {
  min-width: 173px;
}

.client {
  display: flex;
  align-items: center;

  .ava {
    margin-right: 8px;
  }
}

.vd-activator .custom__datepicker {
  width: 87% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

.custom__button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A !important;
}

.custom__card-title {
  justify-content: space-between;
  flex-wrap: wrap;
}

.search_client {
  min-width: 40%;
  display: flex;
  align-items: center;
}
</style>